import { Kullanici } from './kullanici';

export class FaturaAciklama {
    aciklama: string;
    kullanici: Kullanici;

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}
